<template>
  <div>
    <v-row class="pt-5">
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">ชื่อ service</span>
        <v-autocomplete
          v-model="keywordServiceName"
          :items="itemsServiceName"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาชื่อ service"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordServiceName='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordServiceName.splice(keywordServiceName.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">สถานะขอใช้บริการ</span>
        <v-autocomplete
          v-model="keywordStatus"
          :items="statusList"
          item-text="statusTH"
          item-value="status"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาเครือบริษัท"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordCompanyGroup='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordStatus.splice(keywordStatus.indexOf(data.item.status), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item.statusTH }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">หมายเลขคำร้องขอใช้บริการ</span>
        <!-- <v-autocomplete
          v-model="keywordRequestNo"
          :items="itemsServiceNo"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาหมายเลขคำร้องขอใช้บริการ"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordRequestNo='', searchFilterData(), page=1"
        >
          <template v-slot:selection="data">
            <v-chip
              class="mt-1 mb-1"
              color="#EFF4FD"
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              close-icon="mdi-close"
              label
              filter
              small
              @click:close="keywordRequestNo.splice(keywordRequestNo.indexOf(data.item), 1)"
              style="color: #999999;"
            >
              <span style="color: #3776E9;">{{ data.item }}</span>
            </v-chip>
          </template>
        </v-autocomplete> -->
        <v-text-field
          v-model="keywordRequestNo"
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาหมายเลขคำร้องขอใช้บริการ"
          no-data-text="ไม่พบข้อมูล"
          v-on:keyup.enter="searchFilterData(), page=1"
          @click:clear="keywordRequestNo='', searchFilterData(), page=1"
        >
        <template v-slot:append>
          <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
        </template>
        </v-text-field>
      </v-col>
    </v-row>
    <!-- <v-row>
    <v-col cols="6" lg="3" md="6" sm="12" class="pb-0">
      <v-text-field
        v-model="keywordServiceName"
        outlined
        dense
        label="ชื่อ service"
        placeholder="search by keyword"
        class="mt-2"
        v-on:keyup.enter="searchFilterData(), page=1"
      >
      </v-text-field>
    </v-col>
    <v-col cols="6" lg="3" md="6" sm="12" class="pb-0">
      <v-text-field
        v-model="keywordServiceType"
        outlined
        dense
        label="ประเภทเอกสาร"
        placeholder="search by keyword"
        class="mt-2"
        v-on:keyup.enter="searchFilterData(), page=1"
      >
      </v-text-field>
    </v-col>
    <v-col cols="6" lg="3" md="6" sm="12" class="pb-0" v-if="isAdmin">
      <v-autocomplete
        v-model="keywordStatus"
        :items="statusList"
        item-text="statusTH"
        item-value="status"
        outlined
        dense
        label="สถานะ"
        placeholder="ค้นหาสถานะ"
        no-data-text="ไม่พบข้อมูล"
        class="mt-2"
        @change="searchFilterData(), page=1"
      >
      </v-autocomplete>
    </v-col>
    <v-col cols="12" lg="3" md="6" sm="12" class="d-flex align-end">
      <v-row class="pl-3 pr-3" style="margin-bottom: 3px;">
        <v-btn class="btn-search-dep mr-5" style="min-height: 38px;" @click="searchFilterData(), page=1">ค้นหา</v-btn>
        <v-btn class="btn-reset-dep" style="min-height: 38px;" @click="resetFilterData(), page=1">ล้างข้อมูล</v-btn>
      </v-row>
    </v-col>
  </v-row> -->
  <!-- <v-row class=" mb-3 pl-3 pr-3">
    <v-btn
        left
        rounded
        color="success"
        class="mr-2"
        :dark="allowBtnApprove"
        :disabled="!allowBtnApprove"
        @click="clickApprove()"
      >
      <v-icon left dark color="white">fa-check</v-icon>
      Approve
      </v-btn>
      <v-btn
        left
        rounded
        color="red"
        class="mr-2"
        :dark="allowBtnReject"
        :disabled="!allowBtnReject"
        @click="clickReject()"
      >
      <v-icon left dark color="white">fa-ban</v-icon>
      Reject
      </v-btn>
      <v-spacer v-if="$vuetify.breakpoint.name !== 'xs'"/>
      <v-btn
        right
        rounded
        color="success"
        dark
        :class="$vuetify.breakpoint.name !== 'lg'? 'mt-2':'mr-2'"
        @click="createRequestService()"
      >
      <v-icon left dark color="white">fa-plus-circle</v-icon>
      ร้องขอใช้บริการ
      </v-btn>
    </v-row> -->
    <OverlayLoading :loading="loading" />
   <v-data-table
    class="border-table-employee"
    item-key="_id"
    v-model="selected"
    :headers="headers"
    :items="dataSource"
    :single-select="singleSelect"
    :show-select="isAdmin"
    @input="checkAllowBtn()"
    @toggle-select-all="selectAllToggle"
    loading-text="Loading... Please wait"
    :footer-props="{
      'items-per-page-options': [15, 30, 50, 100, -1],
      'items-per-page': 15
    }"
    :server-items-length="total || -1"
    disable-sort
    @update:items-per-page="changePerPage"
    @update:page="changePage"
  >
    <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
      <v-checkbox
        v-if="item.requestStatus=='pending'"
        v-model="item.selected"
        :value="isSelected"
        :readonly="item.requestStatus!=='pending'"
        :disabled="item.requestStatus!=='pending'"
        @change="select($event)"
      />
    </template>
    <template v-slot:[`item.no`]="{ item }">
      {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
    </template>
    <!-- <template v-slot:[`item.requestStatusTH`]="{ item }">
      <tr>
        <td class="text-center">
          <v-chip
            class="ma-2"
            :color="item.requestStatusTH === 'มีสิทธิ์อนุมัติ' ? 'primary' :
            item.requestStatusTH === 'อนุมัติ' ? 'success' :
            item.requestStatusTH === 'ไม่อนุมัติ' ? 'red' :
            item.requestStatusTH === 'ปฏิเสธอนุมัติ' ? 'red' :
            item.requestStatusTH === 'ยกเลิก' ? 'grey' : 'primary'"
            label
            text-color="white"
          >
            {{item.requestStatusTH}}
          </v-chip>
        </td>
      </tr>
    </template> -->
    <template v-slot:[`item.requestStatus`]="{ item }">
      <v-chip
        :color="statusList.filter(e => e.status === item.requestStatus)[0].colorback"
        :text-color="statusList.filter(e => e.status === item.requestStatus)[0].color"
      >
        <span>{{ item.requestStatusTH || '-' }}</span>
      </v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            dark
            icon
            tile
            class="ra-border-button mr-4 ml-1"
            @click="view(item)"
          >
          <v-icon dark color="primary" small>fa-eye</v-icon>
          </v-btn>
        </template>
        <span class="label-table-action">view</span>
      </v-tooltip>
    </template>
  </v-data-table>
  <DialogShowRequestService/>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import OverlayLoading from '@/components/_template/OverlayLoading.vue'
import DialogShowRequestService from './_dialog/dialogShowRequestService'
const axios = require('axios')
const moment = require('moment')
const swal = require('sweetalert')
export default {
  name: 'tree',
  components: {
    OverlayLoading, DialogShowRequestService
  },
  data () {
    return {
      isAdmin: (this.$store.state.user.role).includes('administrator'),
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      keywordRequestNo: '',
      keywordServiceName: '',
      keywordServiceType: '',
      keywordStatus: '',
      statusList: [
        { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF', colorback: '#ECF9FF' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144', colorback: '#ECF8EA' },
        { status: 'waiting', statusTH: 'รออนุมัติ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'waiting', statusTH: 'รอรับทราบ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B', colorback: '#FBE5E4' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#999999', colorback: '#EEEEEE' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144', colorback: '#ECF8EA' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'left',
          value: 'no',
          width: '80',
          groupable: false,
          sortable: false
        },
        { text: 'หมายเลขคำร้องขอใช้บริการ', value: 'serviceNo' },
        { text: 'ประเภทเอกสาร', value: 'serviceType' },
        // { text: 'ผู้ร้องขอ', value: 'requestByName' },
        { text: 'ชื่อ Service', value: 'serviceName' },
        { text: 'สถานะขอใช้บริการ', value: 'requestStatus', width: 'auto', align: 'left' },
        { text: 'วันที่ร้องขอ', value: 'requestDate', width: '17%' },
        { text: 'จัดการ', align: 'center', width: '5%', value: 'actions', sortable: false }
      ],
      selected: [],
      dataSource: [],
      total: -1,
      itemsServiceNo: [],
      itemsServiceName: [],
      serviceTypeList: [],
      requestStatusList: [],
      loading: true,
      perPage: 15,
      page: 1
    }
  },
  mounted () {
    EventBus.$on('requestServiceSearch', this.searchFilterData)
    EventBus.$on('reloadAfterReqService', async (e) => {
      await this.getSelector()
      await this.searchFilterData()
    })
  },
  beforeDestroy () {
    EventBus.$off('requestServiceSearch')
    EventBus.$off('reloadAfterReqService')
  },
  async created () {
    await this.getSelector()
    await this.searchFilterData()
  },
  computed: {
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.searchFilterData()
    },
    changePage (value) {
      this.page = value
      this.searchFilterData()
    },
    async getSelector () {
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/requestServiceSelector`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: { role: '' }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.itemsServiceName = response.data.serviceName || []
              this.itemsServiceNo = response.data.serviceNo || []
              this.requestStatusList = response.data.requestStatus || []
            } else {
              this.itemsServiceName = []
              this.itemsServiceNo = []
              this.requestStatusList = []
            }
          })
          .catch(function (thrown) {
            this.itemsServiceName = []
            this.itemsServiceNo = []
            this.requestStatusList = []
          })
      } catch (error) { } finally {
        this.loading = false
      }
    },
    async searchFilterData () {
      this.selected = []
      this.loading = true
      var self = this
      var searchKeys = {
        serviceNo: this.keywordRequestNo,
        serviceName: this.keywordServiceName,
        // serviceType: this.keywordServiceType,
        requestStatus: this.keywordStatus,
        limit: this.perPage,
        page: this.page
      }
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/getRequestServiceList`,
          method: 'POST',
          data: searchKeys,
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              self.total = response.data.count
              self.dataSource = response.data.result
              self.dataSource.map(e => {
                e.selected = false
                e.requestStatusTH = e.requestStatus === 'pending' ? 'มีสิทธิ์อนุมัติ'
                  : e.requestStatus === 'approve' ? 'อนุมัติ'
                    : e.requestStatus === 'cancel' ? 'ยกเลิก'
                      : e.requestStatus === 'waiting' ? 'รออนุมัติ' : 'ปฏิเสธอนุมัติ'
                e.requestDate = moment(e.requestDate).format('DD/MM/YYYY HH:mm น.')
              })
            } else {
              self.dataSource = []
            }
          })
          .catch(function (thrown) {
            self.dataSource = []
          })
      } catch (error) { } finally {
        this.loading = false
      }
    },
    resetFilterData () {
      this.keywordServiceName = ''
      this.keywordServiceType = ''
      this.keywordStatus = ''
      this.searchFilterData()
    },
    view (item) {
      // console.log(item)
      EventBus.$emit('opendialogMyRequestDetail', true, item)
    },
    createRequestService () {
      // console.log('createRequestService')
      // this.$router.push('/authorityservices/requestservicelist/create')
      this.$router.push('/authorityservices/myservicelist/create')
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    clickApprove () {
      swal('ยืนยันการ Approve รายการที่เลือกใช่หรือไม่', {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'ความเห็น',
            type: 'text'
          }
        },
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then((comment) => {
          if (comment) {
            this.updateStatusRequestService('approve', comment)
          } else if (comment !== null && comment.trim() === '') {
            swal('', 'กรุณาระบุความเห็น', 'warning', {
              button: false,
              timer: 1000
            }).then(() => {
              this.clickApprove()
            })
          }
        })
    },
    clickReject () {
      swal('ยืนยันการ Reject รายการที่เลือกใช่หรือไม่', {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'ความเห็น',
            type: 'text'
          }
        },
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then((comment) => {
          if (comment) {
            this.updateStatusRequestService('reject', comment)
          } else if (comment !== null && comment.trim() === '') {
            swal('', 'กรุณาระบุความเห็น', 'warning', {
              button: false,
              timer: 1000
            }).then(() => {
              this.clickApprove()
            })
          }
        })
    },
    async updateStatusRequestService (task, comment) {
      // console.log('updateStatusRequestService')
      const self = this
      var confirmList = []
      this.selected.forEach(e => {
        confirmList.push(
          {
            requestStatus: task,
            comment: comment,
            _id: e._id
          }
        )
      })
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/updateStatusRequestService`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          approveList: confirmList
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            self.searchFilterData()
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    select (event) {
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          if (item.requestStatus === 'pending') {
            self.selected.push(item)
          }
        })
      } else this.selected = []
    }
  }
}
</script>
